import React, {
    useState, useEffect
} from 'react';

import {
    useNavigate
} from 'react-router-dom';

import {
    Building, Plus, MapPin, CheckCircle, Search, LogOut
} from 'lucide-react';

import axios from 'axios';
const CompanyProjects = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddModal, setShowAddModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [newProject, setNewProject] = useState({
        name: '', address: '', contract_number: ''
    });
    const navigate = useNavigate();
    const userName = localStorage.getItem('userName') || 'Usuario';
    const role = localStorage.getItem('userRole');
    useEffect(() => {
        fetchProjects();
    }, []);
    const fetchProjects = async () => {
        try {
            setLoading(true);
            const res = await axios.get('http://localhost:4000/api/projects');
            setProjects(res.data);
        } catch (err) {
            console.error("Error cargando proyectos:", err);
        } finally {
            setLoading(false);
        }
    };
    const handleCreateProject = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post('http://localhost:4000/api/projects', newProject);
            setProjects([res.data, ...projects]);
            setShowAddModal(false);
            setNewProject({
                name: '', address: '', contract_number: ''
            });
        } catch (err) {
            console.error("Error creando proyecto:", err);
        }
    };
    const selectProject = (project) => {
        localStorage.setItem('activeProjectId', project.id);
        localStorage.setItem('activeProjectName', project.name);
        // Redirigir al dashboard específico de la obra 
        navigate('/dashboard');
    };
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userRole');
        localStorage.removeItem('activeProjectId');
        localStorage.removeItem('activeProjectName');
        navigate('/login');
    };
    const filteredProjects = projects.filter(p => p.name.toLowerCase().includes(searchTerm.toLowerCase()) || (p.address && p.address.toLowerCase().includes(searchTerm.toLowerCase())));
    return (<div className="min-h-screen bg-theme-bg bg-[radial-gradient(ellipse_80%_80%_at_50%_-20%,rgba(37,99,235,0.15),rgba(255,255,255,0))] text-theme-text-primary p-4 md:p-8 font-sans selection:bg-blue-500/30"> {
        /* HEADER */
    } <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-4"> <div> <h1 className="text-4xl font-extrabold tracking-tight text-theme-text-primary mb-2"> Mis Proyectos <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-500">Activos</span> </h1> <p className="text-theme-text-secondary">Bienvenido(a), {
        userName
    }. Selecciona un centro de trabajo.</p> </div> <div className="flex items-center gap-3"> <button onClick={
        handleLogout
    } className="flex items-center gap-2 bg-theme-panel hover:bg-theme-border text-theme-text-primary px-4 py-2 rounded-xl transition-colors font-semibold" > <LogOut size={
        18
    } /> Salir </button> {
                    (role === 'COMPANY_ADMIN' || role === 'SUPER_ADMIN') && (<button onClick={
                        () => setShowAddModal(true)
                    } className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-theme-text-primary px-5 py-2.5 rounded-xl transition-all shadow-lg shadow-blue-500/20 font-bold" > <Plus size={
                        20
                    } /> Nuevo Proyecto </button>)
                } </div> </div> <div className="max-w-7xl mx-auto"> {
                    /* BUSCADOR */
                } <div className="mb-10 relative group"> <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none"> <Search className="text-theme-text-secondary group-focus-within:text-blue-400 transition-colors" size={
                    20
                } /> </div> <input type="text" className="w-full backdrop-blur-md border border-theme-border rounded-2xl py-4 pl-14 pr-4 text-theme-text-primary placeholder-slate-500 focus:outline-none focus:border-blue-500/50 focus: transition-all shadow-inner" placeholder="Buscar por nombre o ubicación..." value={
                    searchTerm
                } onChange={
                    (e) => setSearchTerm(e.target.value)
                } /> </div> {
                /* GRID DE PROYECTOS */
            } {
                loading ? (<div className="flex justify-center py-20"> <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div> </div>) : filteredProjects.length === 0 ? (<div className="text-center backdrop-blur-xl rounded-3xl p-16 border border-theme-border shadow-2xl"> <div className=" w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6 border border-theme-border"> <Building size={
                    40
                } className="text-theme-text-secondary" /> </div> <h3 className="text-2xl font-bold text-theme-text-primary mb-3 tracking-tight">No tienes proyectos activos</h3> <p className="text-theme-text-secondary mb-8 max-w-md mx-auto">Comienza registrando un nuevo centro de trabajo para monitorear incidentes, telemetría y visualizar cámaras.</p> {
                        (role === 'COMPANY_ADMIN' || role === 'SUPER_ADMIN') && (<button onClick={
                            () => setShowAddModal(true)
                        } className="bg-blue-600 hover:bg-blue-500 text-theme-text-primary px-8 py-3.5 rounded-xl transition-all font-bold shadow-lg hover:shadow-blue-500/25" > Crear Primer Proyecto </button>)
                    } </div>) : (<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> {
                        filteredProjects.map((project) => (<div key={
                            project.id
                        } onClick={
                            () => selectProject(project)
                        } className="group bg-theme-panel/80 backdrop-blur-xl border border-theme-border hover:border-blue-500/30 hover:[0.02] rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl hover:shadow-blue-900/20 relative overflow-hidden" > {
                                /* Hover Gradient Overlay */
                            } <div className="absolute inset-0 bg-gradient-to-br from-blue-500/0 to-blue-500/0 group-hover:from-blue-500/[0.03] group-hover:to-transparent transition-all pointer-events-none"></div> <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-all duration-300 translate-x-2 group-hover:translate-x-0"> <div className="bg-blue-500/10 text-blue-400 p-2 rounded-xl backdrop-blur-md border border-blue-500/20"> <CheckCircle size={
                                20
                            } /> </div> </div> <div className="bg-gradient-to-br   w-16 h-16 rounded-2xl flex items-center justify-center border border-theme-border mb-6 group-hover:border-blue-500/30 group-hover:from-blue-500/10 transition-colors shadow-inner relative z-10"> <Building size={
                                28
                            } className="text-blue-400" /> </div> <div className="mb-4 relative z-10"> <h3 className="text-xl font-bold text-theme-text-primary mb-1.5 tracking-tight group-hover:text-blue-300 transition-colors">{
                                project.name
                            }</h3> <div className="flex items-center gap-2 text-sm text-slate-600 text-theme-text-secondary mt-2"> <MapPin size={
                                16
                            } className="text-theme-text-secondary flex-shrink-0" /> <p className="line-clamp-1">{
                                project.address || 'Ubicación no especificada'
                            }</p> </div> </div> <div className="flex items-center justify-between mt-8 pt-5 border-t border-theme-border text-sm relative z-10"> <span className="text-theme-text-secondary font-mono text-xs">ID: {
                                project.contract_number || `P-${project.id
                                }`
                            }</span> <span className="bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 px-3 py-1.5 rounded-lg text-xs font-black uppercase tracking-widest shadow-inner"> {
                                project.status === 'active' ? 'Operativo' : project.status
                            } </span> </div> </div>))
                    } </div>)
            } </div> {
            /* MODAL CREAR PROYECTO */
        } {
            showAddModal && (<div className="fixed inset-0 bg-theme-bg/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"> <div className="bg-theme-panel border border-theme-border rounded-3xl w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh]"> <div className="p-6 border-b border-theme-border flex justify-between items-center bg-theme-panel"> <h2 className="text-xl font-bold text-theme-text-primary flex items-center gap-2"> <Plus className="text-blue-500" /> Registrar Proyecto </h2> <button onClick={
                () => setShowAddModal(false)
            } className="text-theme-text-secondary hover:text-theme-text-primary transition-colors"> &times;
            </button> </div> <div className="p-6 overflow-y-auto"> <form id="createProjectForm" onSubmit={
                handleCreateProject
            } className="space-y-5"> <div> <label className="block text-xs font-bold text-theme-text-secondary text-theme-text-secondary uppercase tracking-wider mb-2">Nombre de la Obra</label> <input type="text" required value={
                newProject.name
            } onChange={
                (e) => setNewProject({
                    ...newProject, name: e.target.value
                })
            } className="w-full bg-theme-bg border border-theme-border text-theme-text-primary px-4 py-3 rounded-xl focus:outline-none focus:border-blue-500 transition-colors" placeholder="Ej. Complejo Residencial Norte" /> </div> <div> <label className="block text-xs font-bold text-theme-text-secondary text-theme-text-secondary uppercase tracking-wider mb-2">Dirección Completa</label> <input type="text" value={
                newProject.address
            } onChange={
                (e) => setNewProject({
                    ...newProject, address: e.target.value
                })
            } className="w-full bg-theme-bg border border-theme-border text-theme-text-primary px-4 py-3 rounded-xl focus:outline-none focus:border-blue-500 transition-colors" placeholder="Av. Principal 123..." /> </div> <div> <label className="block text-xs font-bold text-theme-text-secondary text-theme-text-secondary uppercase tracking-wider mb-2">Número de Contrato (Opcional)</label> <input type="text" value={
                newProject.contract_number
            } onChange={
                (e) => setNewProject({
                    ...newProject, contract_number: e.target.value
                })
            } className="w-full bg-theme-bg border border-theme-border text-theme-text-primary px-4 py-3 rounded-xl focus:outline-none focus:border-blue-500 transition-colors" placeholder="CTR-2026-X" /> </div> </form> </div> <div className="p-6 border-t border-theme-border bg-theme-panel flex justify-end gap-3"> <button type="button" onClick={
                () => setShowAddModal(false)
            } className="px-5 py-2.5 rounded-xl font-bold text-theme-text-secondary text-theme-text-secondary hover:text-theme-text-primary transition-colors" > Cancelar </button> <button type="submit" form="createProjectForm" className="bg-blue-600 hover:bg-blue-500 text-theme-text-primary px-6 py-2.5 rounded-xl transition-all shadow-lg font-bold" > Guardar Proyecto </button> </div> </div> </div>)
        } </div>);
};
export default CompanyProjects;

